module.exports = __webpack_public_path__ + "img/bg-boost-desktop.dc8b886b.svg";